var Scheduler = (function() {
    var tasks = [];
    var minimum = 10;
    var timeoutVar = null;
    var output = {
        add: function(func, context, timer, once) {
            var iTimer = parseInt(timer, 10);
            if (typeof once === 'undefined') {
                once = true;
            }
            context = context && typeof context === 'object' ? context : null;
            if (typeof func === 'function' && !isNaN(iTimer) && iTimer > 0) {
                tasks.push([func, context, iTimer, iTimer * minimum, once, Date.now()]);
            }
        },
        remove: function(func, context) {
            for (
                var i = 0,
                    l = tasks.length; i < l; i++
            ) {
                if (tasks[i][0] === func && (tasks[i][1] === context || tasks[i][1] == null)) {
                    tasks.splice(i, 1);
                    return;
                }
            }
        },
        halt: function() {
            if (timeoutVar) {
                clearInterval(timeoutVar);
            }
        }
    };
    var schedule = function() {
        let i = 0, l, cTask, timeNow;

        for (i, l = tasks.length; i < l; i++) {
            timeNow = Date.now();
            cTask = tasks[i];

            if (cTask instanceof Array && typeof cTask[5] === 'number') {
                if (timeNow - cTask[5] > cTask[2]) {
                    if (cTask[4]) {
                        tasks.splice(i, 1);
                    } else {
                        cTask[5] = timeNow;
                    }
                    cTask[0].apply(cTask[1]);
                }
            } else {
                tasks.splice(i, 1);
            }
        }

    };

    timeoutVar = setInterval(schedule, minimum);
    return output;
})();

module.exports = {
    Scheduler
};
